import React from 'react';
import { ButtonContainer } from './style';

const NoBackgroundAndBorderBtn = ({
  text,
  leftIcon = null,
  onClick,
  isDisabled = false,
}) => {
  return (
    <ButtonContainer
      onClick={onClick}
      disabled={isDisabled}
      isDisabled={isDisabled}
    >
      {leftIcon && <img src={leftIcon} />}
      <span>{text}</span>
    </ButtonContainer>
  );
};

export default NoBackgroundAndBorderBtn;
